// extracted by mini-css-extract-plugin
export var messageSideLeft = "_lv-1";
export var messageSideRight = "_lv-2";
export var subscribeToBackInStockBubbleContainer = "_lv-0";